import { SET_ACTIVE_SEARCH_PARAMETERS } from '../actions/setActiveSearchParameters'

const activeSearchParameters = (state = {}, action) => {
  return action.type === SET_ACTIVE_SEARCH_PARAMETERS ? action.payload : state
}

export default activeSearchParameters
